import { Link } from "react-router-dom";
import { footerLinks, siteName } from "@/mocks/site";

export default function Footer() {
  return (
    <footer className="bg-background-200/60 border-t border-background-300/40 mt-16 md:mt-24">
      <div className="px-4 md:px-8 py-10 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-md bg-primary-500 flex items-center justify-center text-background-50">
                <i className="ri-play-fill text-lg" />
              </span>
              <span className="font-heading text-2xl font-bold text-foreground-50">{siteName}</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-400 max-w-md">
              精选激情影视与短视频的专业内容平台。通过精准分类、多维筛选与编辑推荐，
              帮你在最短时间里找到真正想看的那一部。
            </p>
            <p className="mt-4 text-xs text-foreground-600 flex items-center gap-1.5">
              <i className="ri-information-line" />
              本站内容均为演示数据，视频播放区域为画面示范，不提供真实播放服务。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-medium text-foreground-100 mb-3">
              <Link to="/" className="hover:text-accent-400 transition-colors">
                站内导航
              </Link>
            </h4>
            <ul className="space-y-2">
              {footerLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-foreground-400 hover:text-foreground-50 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-medium text-foreground-100 mb-3">
              <Link to="/about" className="hover:text-accent-400 transition-colors">
                联系我们
              </Link>
            </h4>
            <ul className="space-y-2.5 text-sm text-foreground-400">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-foreground-500" />
                contact@passion-video.demo
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-foreground-500" />
                工作日 10:00 - 19:00
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-shield-check-line text-foreground-500" />
                仅限 18 岁以上用户浏览
              </li>
            </ul>
            <div className="flex items-center gap-2 mt-4">
              {["ri-weibo-line", "ri-wechat-line", "ri-mail-line"].map((icon) => (
                <span
                  key={icon}
                  className="w-8 h-8 rounded-md bg-background-300/50 flex items-center justify-center text-foreground-300"
                >
                  <i className={icon} />
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-300/40 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-600">© 2026 {siteName}. 演示站点，仅供产品展示使用。</p>
          <div className="flex items-center gap-4 text-xs text-foreground-600">
            <span>使用说明</span>
            <span>版权声明</span>
            <span>隐私政策</span>
          </div>
        </div>
      </div>
    </footer>
  );
}